import React, { useEffect } from "react";
import { motion, useAnimationControls } from "framer-motion";
import { Skill } from "../../types";
import SkillTooltip from "./SkillTooltip";

interface SkillBarProps {
  skill: Skill;
  onClick: (skill: Skill) => void;
}

const SkillBar: React.FC<SkillBarProps> = ({ skill, onClick }) => {
  const controls = useAnimationControls();
  const percentage = skill.level * 20;

  // Animazione al passaggio del mouse
  const handleMouseEnter = async () => {
    controls.set({ width: "0%" });
    await controls.start({
      width: `${percentage}%`,
      transition: { duration: 1.5, ease: "easeOut" },
    });
  };

  // Animazione iniziale al mount
  useEffect(() => {
    controls.start({
      width: `${percentage}%`,
      transition: { duration: 1, delay: 0.2, ease: "easeOut" },
    });
  }, [controls, percentage]);

  return (
    <motion.div
      initial={{ opacity: 0, x: -10 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.3 }}
      className="cursor-pointer group"
      onMouseEnter={handleMouseEnter}
      onClick={() => onClick(skill)}
    >
      <div className="flex justify-between items-center mb-2">
        <SkillTooltip skillName={skill.name}>
          <span className="text-sm font-medium text-gray-900 dark:text-gray-200 group-hover:text-primary-600 dark:group-hover:text-primary-400 transition-colors">
            {skill.name}
          </span>
        </SkillTooltip>
        <span className="text-sm font-bold text-primary-600 dark:text-primary-400">
          {percentage}%
        </span>
      </div>

      <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2.5">
        <motion.div
          initial={{ width: 0 }}
          animate={controls}
          className="h-2.5 rounded-full bg-gradient-to-r from-primary-600 to-indigo-600 dark:from-primary-500 dark:to-indigo-500"
        />
      </div>
    </motion.div>
  );
};

export default SkillBar;
